module.exports = __webpack_public_path__ + "assets/img/11_742_big.e0c5daf7.jpg";